var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreparationStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#0085E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0264 9.23628C16.2008 9.41069 16.2008 9.69272 16.0264 9.86528L11.1279 14.7656C10.9535 14.94 10.6715 14.94 10.4989 14.7656L7.97363 12.2421C7.79922 12.0677 7.79922 11.7857 7.97363 11.6131C8.14804 11.4406 8.43008 11.4387 8.60263 11.6131L10.8106 13.8211L15.3955 9.23628C15.5699 9.06187 15.8519 9.06187 16.0245 9.23628H16.0264Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreparationStatus);
export default __webpack_public_path__ + "static/media/preparation-status.89dc4054.svg";
export { ForwardRef as ReactComponent };